import { z } from 'zod';
import { ERPConnectionInfoSchema, ERPConnectionInfo } from './ERPConnectionInfoViewModel';

export const ERPApiReadConfigurationFormSchema = z.object({
    Id: z.number().nullable(),
    CompanyId: z.number(),
    InvoiceProfileId: z.number(),
    ERPName: z.string().trim().min(1, { message: 'ERP Name is required' }),
    ERPVersion: z.string().trim().min(1, { message: 'ERP Version is required' }),
    ERPConnectionInfo: ERPConnectionInfoSchema,
    Active: z.boolean(),
    LastReadTime: z.any().optional(),
});

export type ERPApiReadConfigurationFormViewModel = z.infer<typeof ERPApiReadConfigurationFormSchema>;

export interface ERPApiReadConfigurationViewModel {
    Id: number | null;
    CompanyID: number;
    InvoiceProfileId: number;
    CreatedTime: Date | null;
    LastUpdateDate: Date;
    ERPName: string;
    ERPVersion: string;
    ERPConnectionInfo: ERPConnectionInfo;
    LastReadTime: string | Date | null;
    Active: boolean;
    RowVersion: string;
}
